import { useMediaQuery } from "@vueuse/core";

export function useCanHover() {
  return { canHover: useMediaQuery("(hover: hover)") };
}
